<template>
  <v-app id="app">
    <toolbar></toolbar>
    <!-- <login v-if="!currentUser"></!-->

    <v-content>
      <v-container fluid class="fill-height px-0 pt-0" white>
        <v-layout row wrap>
          <v-flex xs12>
            <!-- <keep-alive> -->
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
            <!-- </keep-alive> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <!-- <login v-else></login> -->
    <!-- <v-footer
      height="auto"
      fixed
      color="primary lighten-1"
    >
      <v-layout
        justify-center
        row
        wrap
      >
        <v-btn
          v-for="link in ['links']"
          :key="link"
          color="white"
          flat
          round
        >
          {{ link }}
        </v-btn>
        <v-flex
          primary
          lighten-2
          py-3
          text-xs-center
          white--text
          xs12
        >
          &copy;2018 — <strong>Vuetify</strong>
        </v-flex>
      </v-layout>
    </v-footer> -->
  </v-app>
</template>

<script>
import Toolbar from '@/components/layout/Toolbar.vue'

export default {
  name: 'app',
  data: () => ({
    dialog: false,
    transitionName: 'slide-left'
    // drawer: null,
    // sheet: false,
    // currentUser: ''
    // currentUser: this.$store.state.currentUser
  }),
  beforeRouteUpdate (to, from, next) {
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    next()
  },
  props: {
    source: String,
    filters: []
  },
  components: {
    Toolbar
  }
}
</script>

<style>
.v-btn--active {
  color: white !important;
  background-color: black;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
/* #app { */
/* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
/* margin-top: 60px; */
/* } */
</style>



// WEBPACK FOOTER //
// src/App.vue